/**
 * Divider with Heading.
 *
 * @package
 */

/**
 * Internal dependencies.
 */
 import Edit from './edit';
 /**
  * WordPress Dependencies.
  */ 
 import { registerBlockType } from '@wordpress/blocks';
 import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';
 import { paragraph } from '@wordpress/icons'; 
 import { __ } from '@wordpress/i18n';
 /**
  * Register block type.
  */
 registerBlockType( 'ssvreutlingen-blocks/textdefault', {

	apiVersion: 2,
	 /**
	  * Block title.
	  *
	  * @type {string}
	  */
	 title: __( 'SSV Text default', 'ssvreutlingen' ),
 
	 /**
	  * Block icon.
	  *
	  * @type {string}
	  */
	 icon: paragraph,
	 /**
	 * Support Align wide/full.
	 *
	 * @type {string}
	 */
	supports: {
		anchor: true,
		align: ['wide','full'], 
    },
	attributes: {
		align: {
			type: 'string',
			default: 'wide'
		},
		lock: {
			type: "object",
			default: {
				"move": true,
				"remove": true
			},
		}
	},
	
	 /**
	  * Block description.
	  *
	  * @type {string}
	  */
	 description: __( 'Einleitungen.', 'ssvreutlingen' ),
 
	 /**
	  * Block category.
	  *
	  * @type {string}
	  */
	 category: 'ssvreutlingen',

	 edit: Edit,

 
	 /**
	  * Save function.
	  *
	  * @param {Object} props                    Props
	  *
	  * @param          props.attributes
	  * @param          props.attributes.content
	  * @return {Object} Content.
	  */
	 save() {

		const blockProps = useBlockProps.save();

		 return (

			<div  { ...blockProps }>
			<InnerBlocks.Content />
			</div>
			

		);
	 },
 } );
 